module.exports = __webpack_public_path__ + "img/auto.205d4a94.svg";